import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A turing machine in 133 bytes of javascript",
  "description": "",
  "published": "2011-11-28T00:00:00.000Z",
  "redirect_from": ["/blog/a-turing-machine-in-133-bytes-of-javascript/swizec/3069"],
  "categories": "Languages, Programming, Turing machine, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-28-at-11.16.05-AM.png",
        "alt": "Multiply turing machine",
        "title": "Multiply turing machine"
      }}></img></p>
    <p>{`The fact it took me 20 lines of javascript to implement a `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/nondeterministic-turing-machine-simulator-in-23-lines-of-javascript/swizec/3047",
        "title": "Nondeterministic turing machine simulator in 23 lines of JavaScript"
      }}>{`nondeterministic turing machine simulator`}</a>{`last week kept me up at night. All weekend. Too much code for something so simple and I kept having this gut feeling implementing a basic version shouldn't take more than 140 bytes.`}</p>
    <p>{`Sunday afternoon I sat down for about an hour, collected my thoughts, and started pumping out code with cryptic variable names. It was beautiful, first version was around 250 bytes, then 170, then 156, then `}<em parentName="p">{`bam!`}</em>{` 133. Oh yeah baby!`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function tm(I, t, e, s, i, c, k) {
  i = 0;
  while (s != e) {
    c = t[i];
    k = c ? I[s][c] : I[s].B;
    if (!k) return false;
    t.splice(i, 1, k.w);
    i += k.m;
    s = k.n;
  }
  return t;
}
`}</code></pre>
    <p>{`I was left with a horribly looking yet simple function. All it needs are some instructions, the initial state of the tape as a list, an end state and a start state. It will return either the final tape state or false if the end state is never reached. 'B' is considered a blank state and the tape behaves as infinite in both directions.`}</p>
    <p>{`If you want a file ready-made to run in node, go to `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/random-coding/blob/master/turing-140.js"
      }}>{`my github`}</a>{`.`}</p>
    <p>{`Here's a far less interesting but readable version of the same code (324 bytes):`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function tm(I, tape, end, state, i, cell, current) {
  i = 0;
  while (state != end) {
    cell = tape[i];
    current = cell ? I[state][cell] : I[state].B;
    if (!current) return false;
    tape.splice(i, 1, current.w);
    i += current.m;
    state = current.n;
  }
  return tape;
}
`}</code></pre>
    <p>{`For testing I used a simple multiply program that basically turns `}<em parentName="p">{`111`}</em>{` into `}<em parentName="p">{`1110111`}</em>{`. For any length string of one's. I decided to be pretty strict about inputs this time because I didn't have the room to transform anything, so this is what the algorithm's implementation ends up looking like`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{"q0": {"1": {"w": "B", "m": 1, "n": "q1"}},
 "q1": {"1": {"w": "1", "m": 1, "n": "q1"},
        "0": {"w": "0", "m": 1, "n": "q2"},
        "B": {"w": "0", "m": 1, "n": "q2"}},
 "q2": {"1": {"w": "1", "m": 1, "n": "q2"},
        "B": {"w": "1", "m": -1, "n": "q3"}},
 "q3": {"1": {"w": "1", "m": -1, "n": "q3"},
        "0": {"w": "0", "m": -1, "n": "q3"},
        "B": {"w": "1", "m": 1, "n": "q4"}},
 "q4": {"1": {"w": "B", "m": 1, "n": "q1"},
        "0": {"w": "0", "m": 1, "n": "q5"}}}
`}</code></pre>
    <p>{`Solving this little puzzle was heaps of fun and the result is code that I would never ever want to see in production (if you code like that there is a special circle of hell for you) ... now I'm just left wondering if there's a smaller solution in a less verbose language. Can it be made so small I could tweet "Turing Machine: `}{`<`}{`code>"?`}</p>
    <p>{`Food for thought.`}</p>
    <p>{`PS: the shortest solution by `}<a parentName="p" {...{
        "href": "https://gist.github.com/1400509"
      }}>{`subzey`}</a>{` in 79 bytes`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function(a,b,c,d,e){for(e=0;d<c;)with(a[d][b[e]||"b"])b[e]=w,e+=m,d=n;return b}="" <="" pre="">
<h6 class="zemanta-related-title" style="font-size: 1em;">Related articles</h6>
<ul class="zemanta-article-ul">
    <li class="zemanta-article-ul-li"><a href="http://swizec.com/blog/nondeterministic-turing-machine-simulator-in-23-lines-of-javascript/swizec/3047">Nondeterministic turing machine simulator in 23 lines of JavaScript</a> (swizec.com)</li>
    <li class="zemanta-article-ul-li"><a href="http://stackoverflow.com/questions/7366513/is-turing-machine-is-a-real-device-or-an-imaginary-concept">Is turing machine is a real device or an imaginary concept?</a> (stackoverflow.com)</li>
    <li class="zemanta-article-ul-li"><a href="http://shebang.ws/turing-completeness-bullshit.html">Turing completeness bullshit</a> (shebang.ws)</li>
    <li class="zemanta-article-ul-li"><a href="http://work.damow.net/random/bf-turing/">The Brainfu*k Turing Machine (Javascript)</a> (work.damow.net)</li>
</ul>
<div class="zemanta-pixie" style="margin-top: 10px; height: 15px;"><a class="zemanta-pixie-a" title="Enhanced by Zemanta" href="http://www.zemanta.com/"><img class="zemanta-pixie-img" style="border: none; float: right;" src="http://img.zemanta.com/zemified_e.png?x-id=01ad0c53-59aa-4646-b7dd-ad6f892a820f" alt="Enhanced by Zemanta"></a></div></c;)with(a[d][b[e]||"b"])b[e]=w,e+=m,d=n;return>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      